import Head from 'next/head'
import { DSSpacer } from '@/components/ds/Spacer/Spacer'
import React from 'react'
import { DSButton, DSIcon, DSFlex, DSText } from '@zoe/ds-web'
import { Header } from '@/components/elements/header/Header'
import { DSGrid, DSGridBlock } from '@/components/ds/Grid/Grid'
import { useRouter } from 'next/router'
import { NewLoginForm } from './NewLoginForm'
import { trackCtaClick } from '@/lib/gtm/gtmV2'

export const LoginPage = () => {
  const router = useRouter()

  return (
    <>
      <Head>
        <title>ZOE - Login</title>
        <link rel="icon" href="/favicon.png" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta name="robots" content="noindex,nofollow" />
      </Head>

      <Header />

      <DSSpacer size={96} direction="vertical" />
      <DSSpacer size={96} direction="vertical" />
      <DSGrid>
        <DSGridBlock
          breakConfig={{
            s: { colSpan: 2 },
            m: { colSpan: 4, offset: 1 },
            l: { colSpan: 4, offset: 4 },
            xl: { colSpan: 4, offset: 4 },
          }}
        >
          <DSFlex direction="column" justifyContent="center">
            <DSText variant="fluid-heading-600" align="center">
              Log in
            </DSText>
            <DSSpacer size={24} direction="vertical" />
            <DSText variant="fluid-paragraph-300" align="center">
              For existing or past ZOE members to manage your account details and subscriptions to ZOE products
            </DSText>
            <DSSpacer size={16} direction="vertical" />

            <NewLoginForm />
            <DSSpacer size={40} direction="vertical" />

            <DSText variant="fluid-heading-500">Not a member yet?</DSText>
            <DSSpacer size={16} direction="vertical" />
            <DSButton
              variant="secondary"
              size="large"
              onPress={() => {
                router.push('/buymembership')
                trackCtaClick('account', 'login-page-view-membership-plans')
              }}
            >
              <DSText variant="fluid-paragraph-200" weight="semiBold">
                View our membership plans
              </DSText>
              <DSSpacer size={8} direction="horizontal" />
              <DSIcon name="arrow-right" size={16} />
            </DSButton>
          </DSFlex>
        </DSGridBlock>
      </DSGrid>
    </>
  )
}
